const SportsLabel = Object.freeze({
  football: 'Integrations_SportsFeedStream_Label_Football',
  horseracing: 'Integrations_SportsFeedStream_Label_HorseRacing'
})

export { SportsLabel }



// WEBPACK FOOTER //
// ./src/modules/integrations/types/sportsfeedstream/enum/SportsLabelEnum.js